//if feature map is empty, then all sports are supported
const FEATURE_MAP = {
    "betIdeas":[],
    "propIdeas":[],
    "gameLogs":["NFL", "NBA", "NHL", "MLB", "WNBA", "CFB", "NCAAB"],
    "historicalMatchup":["NFL", "NBA", "NHL", "MLB", "WNBA", "CFB", "NCAAB"],
    "playerPropAnalyzer": ['NFL'],
    "injuries":["DISABLED"],
    "playerPropInsights":["NFL"],
    "parlayGenerator": true
}

export const isFeatureSupported = (feature, sport) => {
    if (FEATURE_MAP[feature].length === 0) return true;
    return FEATURE_MAP[feature].includes(sport);
}
